import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { INetworkSettings } from './settings-types';
import { Observable } from 'rxjs';

@Injectable()
export class SettingsService {

  constructor(private http: HttpClient) { }

  readonly getSettingsUrl = '/settings/getSettings';
  readonly saveSettingsUrl = '/settings/save_settings_data.json';
  readonly validSettingsUrl = '/settings/validSettings';
  
  getSettings() {
    return this.http.get<INetworkSettings>(this.getSettingsUrl);
  }

  saveSettings(settings: INetworkSettings): Observable<string> {
    return this.http.post<string>(this.saveSettingsUrl, settings);
  }

  validSettings() {
    return this.http.get<{valid: boolean}>(this.validSettingsUrl);
  }
}

let settingsServiceStub: Partial<SettingsService> = {};
export { settingsServiceStub };